import React from "react";
import Export from "components/DataEntryExport";

const DataEntryExport = () => <Export action="data-entry" />;

export default DataEntryExport;
